import ProposalOwners from './ProposalOwners';

export default ProposalOwners;
